<sh-page-layout>
  <sh-header>
    <sh-language-picker position="right"></sh-language-picker>
  </sh-header>

  <div class="reset-password row">
    <img
      src="../../../assets/shipm8-logo.svg"
      alt="{{ 'portal' | translate }}"
    />

    <div class="form-wrapper">
      <form [formGroup]="form">
        <sh-text-input
          formControlName="emailAddress"
          placeholder="{{ 'shared.terms.email' | translate }}"
        >
        </sh-text-input>
        <div class="mt-3">
          <sh-button [disabled]="isLoading" (click)="resetPasswordRequest()"
            >{{ 'account.resetPassword.title' | translate }}</sh-button
          >
          <sh-button link [routerLink]="'/account/login'">
            {{ 'shared.terms.backToLogin' | translate }}
          </sh-button>
        </div>
      </form>
    </div>

    <sh-loading-indicator
      class="text-center"
      *ngIf="isLoading"
    ></sh-loading-indicator>
  </div>
</sh-page-layout>
